import { IStore } from 'Store/.';
import { createSelector } from 'reselect';

const getIsFetching = (state: IStore) => state.infoCookies.isFetching;
const getIsFetchFailed = (state: IStore) => state.infoCookies.isFetchFailed;
const getCookiesContent = (state: IStore) => state.infoCookies.content;

export {
  getIsFetching,
  getIsFetchFailed,
  getCookiesContent,
};


// WEBPACK FOOTER //
// ./src/components/CookiesPopup/Redux/selectors.tsx